import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { RootStoreContext } from "../../core/store/rootStore";

const Home = () => {
    const rootStore = useContext(RootStoreContext);
    const { user } = rootStore.userStore;
    const currentUser = Object.assign({}, user);

    return (
      <div className="full-text">
          <b>TOKEN</b> <br />
          {currentUser.authorizationToken}
      </div>
    );
};

export default observer(Home);